export default {"src":"/pro/_next/static/media/axelar-logo.9b0984ec.svg","height":8,"width":31,"blurWidth":0,"blurHeight":0};